import React, { useEffect, useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import Control from '../../components/Control/Control';
import StrategyConfig from '../../components/StrategyConfig/StrategyConfig';
import ClientLots from '../../components/ClientLots/ClientLots';
import StrategyBindings from '../../components/StrategyBindings/StrategyBindings';
import { useShellNav } from '../shell/ShellNavContext';
import { shellTokens } from '../shell/theme/shellTheme';

const ADMIN_TABS = [
    { value: 'control', label: 'Control' },
    { value: 'config', label: 'Strategy config' },
    { value: 'lots', label: 'Client lots' },
    { value: 'bindings', label: 'Strategy accounts' },
];

const DEFAULT_TAB = ADMIN_TABS[0].value;
const VALID_TABS = new Set(ADMIN_TABS.map((tab) => tab.value));

const subTabSx = (active) => ({
    border: `1px solid ${active ? 'rgba(37, 99, 235, 0.25)' : shellTokens.border}`,
    bgcolor: active ? 'rgba(37, 99, 235, 0.1)' : shellTokens.surface,
    borderRadius: '8px',
    px: 1.75,
    py: 0.85,
    fontSize: '0.78rem',
    fontWeight: 700,
    color: active ? shellTokens.primary : shellTokens.muted,
    textTransform: 'none',
});

const AdminPage = () => {
    const { subTab, setSubTab } = useShellNav();
    const [activeTab, setActiveTab] = useState(DEFAULT_TAB);

    useEffect(() => {
        if (subTab && VALID_TABS.has(subTab)) {
            setActiveTab(subTab);
        }
    }, [subTab]);

    const handleTabClick = (value) => {
        setActiveTab(value);
        setSubTab(value);
    };

    return (
        <Box>
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mb: 1.75 }}>
                {ADMIN_TABS.map((tab) => (
                    <Button
                        key={tab.value}
                        sx={subTabSx(activeTab === tab.value)}
                        onClick={() => handleTabClick(tab.value)}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Stack>

            {activeTab === 'control' ? <Control /> : null}
            {activeTab === 'config' ? <StrategyConfig /> : null}
            {activeTab === 'lots' ? <ClientLots /> : null}
            {activeTab === 'bindings' ? <StrategyBindings /> : null}
        </Box>
    );
};

export default AdminPage;
